import * as React from 'react';

// tslint:disable:max-line-length
export const HighwayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fill="#757575"
      fillOpacity=".54"
      fillRule="evenodd"
      d="M12.037 4.506a.872.872 0 0 0-.83-.59H4.793a.877.877 0 0 0-.83.59L2.75 8v4.667c0 .32.262.583.583.583h.584c.32 0 .583-.262.583-.583v-.584h7v.584c0 .32.262.583.583.583h.584c.32 0 .583-.262.583-.583V8l-1.213-3.494zm-7.245 5.827a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75zm6.416 0a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75zm-7.29-2.916l.874-2.625h6.416l.875 2.625H3.917h.001z"
    />
  </svg>
);
